import { IBlocActuTheme, TypeNameBlockActuTheme } from '../../../components/categorie/actu-theme';
import { IBlockPresenter } from '../../presenter';

export interface IActuThemeBo {
  __typename: typeof TypeNameBlockActuTheme;
  actuThemeSummary: string | null;
  actuThemeTitle: string | null;
  actuTheme: { tid: number; entity: { name: string } };
}

export class ActuThemePresenter implements IBlockPresenter {
  parse(data: IActuThemeBo): IBlocActuTheme {
    if (!data) {
      return null;
    }

    return {
      __typename: TypeNameBlockActuTheme,
      title: data.actuThemeTitle,
      chapo: data.actuThemeSummary ?? '',
      taxonomy: data.actuTheme?.tid + '',
    };
  }
}
